@let fieldSchema = schema();
@let formCtrl = internalControl();

@if (fieldSchema) {
  @let ctrl = internalControl();
  @let ctrlInvalid = ctrl.invalid;
  @let hasSuggestions = !!fieldSchema.suggestions?.length;
  @let suggestions = filteredSuggestions();
  @let isListOpen = listOpen();
  <div class="relative">
    <input
      #inputRef
      [type]="fieldSchema.inputType"
      [formControl]="formCtrl"
      [ngClass]="{
        'border-d-red-main': ctrlInvalid,
        'border-d-light-shade': !ctrlInvalid
      }"
      class="border-d-light-shade bg-d-light-main text-d-primary-main focus:border-d-primary-main focus:ring-d-primary-main w-full border p-2 text-left outline-hidden focus:ring-1"
      [class.pr-8]="hasSuggestions"
      [placeholder]="fieldSchema.placeholder ?? '' | translate"
      [attr.role]="hasSuggestions ? 'combobox' : null"
      [attr.autocomplete]="hasSuggestions ? 'off' : null"
      [attr.aria-autocomplete]="hasSuggestions ? 'list' : null"
      [attr.aria-expanded]="hasSuggestions ? isListOpen : null"
      [attr.aria-controls]="hasSuggestions ? suggestionsId : null"
      [attr.aria-activedescendant]="isListOpen && activeIndex() >= 0 ? suggestionsId + '-' + activeIndex() : null"
      (focus)="openSuggestions()"
      (click)="openSuggestions()"
      (blur)="closeSuggestions()"
      (input)="onInput($event)"
      (keydown)="onKeydown($event)"
    />
    @if (hasSuggestions) {
      <gs-icon
        [iconName]="isListOpen ? 'chevron-up' : 'chevron-down'"
        iconType="fa-regular"
        class="text-d-primary-main pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-xs"
        aria-hidden="true"
      ></gs-icon>
      <!-- Fixed, so dialogs with overflow-hidden do not clip it; mousedown keeps the input focused -->
      <ul
        [id]="suggestionsId"
        role="listbox"
        class="bg-d-light-main border-d-light-shade fixed z-50 mt-3 overflow-auto border shadow-lg"
        [class.hidden]="!isListOpen"
        [gsAnchoredPanel]="inputRef"
        [gsAnchoredPanelOpen]="isListOpen"
        (mousedown)="$event.preventDefault()"
      >
        @for (suggestion of suggestions; track suggestion; let i = $index) {
          <li
            [id]="suggestionsId + '-' + i"
            role="option"
            class="text-d-primary-main cursor-pointer p-2 transition-colors"
            [class.bg-d-light-shade]="i === activeIndex()"
            [attr.aria-selected]="i === activeIndex()"
            (mouseenter)="activeIndex.set(i)"
            (click)="selectSuggestion(suggestion)"
          >
            {{ suggestion }}
          </li>
        }
      </ul>
    }
  </div>
}
